import Vue from 'vue'
import Vuex from 'vuex'
import _this from '@/main.js'
import { findUserById, PriceTypeList } from '@/api'
import { getToken } from '@/utils/auth'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    userInfo: null,
    priceTypeList: []
  },
  mutations: {
    logOut(state, payload) {
      state.userInfo = null
    },
    setUserInfo(state, payload) {
      state.userInfo = payload
    },
    setPriceTypeList(state, payload) {
      state.priceTypeList = payload
    },
  },
  actions: {
    //获取用户信息
    async getUser(context) {
      await findUserById({
        object: {
          id: JSON.parse(getToken()).id,
        },
      }).then(res => {
        if (!res) return
        let userInfo = res.data.userInfo
        userInfo.objectName = userInfo.userEntity.objectName
        if (userInfo.objectName === null) userInfo.objectName = ''
        if (userInfo.id === '0') userInfo.objectName = '*'
        context.commit('setUserInfo', userInfo);
      })
    },
    //获取分类列表
    async getPriceTypeList(context) {
      await PriceTypeList({
        object: {
          id: "",
        },
        pageNum: 0,
        pageSize: 0,
      }).then(res => {
        if (!res) return
        context.commit('setPriceTypeList', res.data.reverse());
      })
    }
  },
})
